module.exports = __webpack_public_path__ + "static/img/icon_faq.401dc540.svg";